module.exports = __webpack_public_path__ + "static/media/as7cr823.080712dc.png";